<template>
  <div class="selections">
    <div class="selections-alert" v-if="alert.message">
      <div class="alert alert-dismissable fade show"
        :class="'alert-' + alert.type">
        <button type="button" class="close" data-dismiss="alert">
          <span>&times;</span>
        </button>
        {{ alert.message }}
      </div>
    </div>
    <form class="selections-form" @submit.prevent="onSubmit" @change="onChange">
      <div class="selections-side left row">
        <h4>
          Links
          <small>
            <a :href="previewHref('left.jpg')" target="_blank">Vorschau</a>
          </small>
        </h4>
        <selections-index :all="creams" :ids="selectedIds"
          :selected="selectedCreams.left">
        </selections-index>
      </div>
      <div class="selections-side right row">
        <h4>
          Rechts
          <small>
            <a :href="previewHref('right.jpg')" target="_blank">Vorschau</a>
          </small>
        </h4>
        <selections-index :all="creams" :ids="selectedIds"
          :selected="selectedCreams.right">
        </selections-index>
      </div>
      <div class="row" v-if="isAuthorized('selections-edit', id)">
        <div class="col col-lg-2 col-3">
          <button class="btn btn-primary save" :disabled="!touched">
            Aktualisieren
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import selectionsIndex from './_index'
import auth from '../../../services/auth'
import flash from '../../../services/flash'

export default {
  components: { selectionsIndex },

  props: ['id'],

  data () {
    return {
      creams: [],
      selectedCreams: {
        left: [],
        right: []
      },
      alert: {},
      touched: false
    }
  },

  computed: {
    location () {
      return { 1: 'Mannheim', 2: 'Limburgerhof' }[this.id]
    },

    selectedIds () {
      const leftIds = this.selectedCreams.left.map(cream => cream.id)
      const rightIds = this.selectedCreams.right.map(cream => cream.id)
      return leftIds.concat(rightIds)
    }
  },

  watch: {
    $route () {
      this.alert = {}
      this.fetch()
    }
  },

  created () {
    this.$http.get('/api/creams')
      .then((res) => {
        this.creams = res.body.creams
        this.fetch()
      })
      .catch(reason => console.log(reason))
  },

  methods: {
    onChange () {
      this.touched = true
    },

    onSubmit () {
      this.$http.post(
        `/api/selections/${this.id}`,
        {creamIds: this.selectedIds}
      )
        .then(() => {
          this.touched = false
          this.alert = flash.now({
            type: 'info',
            message: `Auswahl am Standort ${this.location} aktualisiert`
          })
        })
        .catch(reason => console.log(reason))
    },

    fetch () {
      this.selectedCreams.left = new Array(8).fill('')
      this.selectedCreams.right = new Array(8).fill('')
      this.$http.get(`/api/selections/${this.id}`)
        .then((res) => {
          const selections = res.body.creams
          selections.forEach((selection, index) => {
            const cream = findCreamById(this.creams, selection['cream_id'])
            const {position} = selection
            if (position < 8) {
              Vue.set(this.selectedCreams.left, position, cream)
            } else {
              Vue.set(this.selectedCreams.right, position - 8, cream)
            }
          })
        })
    },

    isAuthorized (action, restriction) {
      return auth.isAuthorized(action, restriction)
    },

    previewHref (name) {
      return `/resources/rendered/${this.id}/${name}`
    }
  }
}

function findCreamById (creams, id) {
  return creams.find((cream) => cream.id === id)
}
</script>

<style scoped lang="scss">
  @import '../../../assets/styles/variables';

  .selections {
    margin-bottom: $spacer-y*4;
  }

  .selections-side {
    padding: 50px;

    & + & {
      margin-top: $spacer-y*4;
    }

    h4 {
      small {
        font-size: $font-size-sm;
      }

      a {
        color: inherit;
      }
    }

    &.left {
      background-color: rgba($color-deeppurple, .05);

      h4 {
        color: rgba($color-deeppurple, 0.7);
      }
    }

    &.right {
      background-color: rgba($color-lemonyellow, .05);

      h4 {
        color: rgba($color-lemonyellow, 0.9);
      }
    }
  }

  .selections-form {
    margin-top: $spacer-y*6;
  }

  .selections-alert {
    position: absolute;
    left: 0;
    right: 0;
    margin-top: -$spacer-y*4.5;
  }

  .btn {
    &.save {
      width: 100%;
      margin: $spacer-y*2 0;
    }

    &[disabled] {
      background-color: $color-darkgray;
      border-color: $color-darkgray;
    }
  }
</style>



// WEBPACK FOOTER //
// edit.vue?7a25722e